import React, { createRef, Fragment, useContext } from "react";
import { Breadcrumbs } from "../../../../AbstractElements";
import { Add, Cancel } from "../../../../Constant";
import { Space, Button, Form, Col, Row, Input, DatePicker } from "antd";
import { useNavigate, Link } from "react-router-dom";
import { Container, Card, CardBody } from "reactstrap";
import axios from "axios";
import { toast } from "react-toastify";
import moment from "moment";
import { ProjectApi } from "../../../../api";
const Newproject = () => {
  const formRef = createRef();
  const history = useNavigate();
  const addProject = () => {
    const updatedValues = formRef.current.getFieldsValue();
    const values = new FormData();
    values.append(
      "start_date",
      moment(updatedValues?.start_date).format("YYYY-MM-DD")
    );
    values.append(
      "end_date",
      moment(updatedValues?.end_date).format("YYYY-MM-DD")
    );
    values.append("project_name", updatedValues?.title);
    values.append("organisation", 1);
    axios
      .post(`${ProjectApi}`, values)
      .then((res) => {
        toast.success("Project Added");
        history(`/app/project/project-list`);
      })
      .catch(() => {
        toast.error("Something went wrong!");
      });
  };

  return (
    <Fragment>
      <Breadcrumbs
        parent="Project"
        title="Create Project"
        mainTitle="Create Project"
      />
      <Container fluid={true}>
        <div>
          <Card>
            <CardBody>
              <Form
                layout="vertical"
                id="projectForm"
                ref={formRef}
                onFinish={addProject}
              >
                <Row gutter={24}>
                  <Col sm={12}>
                    <Form.Item
                      name={"title"}
                      label="Project name"
                      rules={[
                        {
                          required: true,
                          pattern:/^[^*|\":<>[\]{}`\\()';@&$]+$/,
                          message: "Project name is required",
                        },
                      ]}
                    >
                      <Input placeholder="Project name" />
                    </Form.Item>
                  </Col>
                  <Col sm={12}>
                    <Form.Item name={"pincode"} label="Pincode">
                      <Input placeholder="Enter pincode" />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col sm={12}>
                    <Form.Item name={"pincode"} label="Pincode">
                      <Input placeholder="Enter pincode" />
                    </Form.Item>
                  </Col>
                  <Col sm={12}>
                    <Form.Item name={"city"} label="City"  rules={[
                        {
                          pattern:/^[A-Za-z]+[A-Za-z ]*$/,
                          message: "Enter valid City name",
                        },
                      ]}>
                      <Input placeholder="Enter city" />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col sm={12}>
                    <Form.Item name={"start_date"} label="Start Date">
                      <DatePicker placeholder="Start Date" className="w-100" />
                    </Form.Item>
                  </Col>
                  <Col sm={12}>
                    <Form.Item name={"end_date"} label="End Date">
                      <DatePicker placeholder="End Date" className="w-100" />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col>
                    <Space className="mb-0">
                      <Button htmlType="submit" form="projectForm">
                        {Add}
                      </Button>
                      <Button
                        type="primary"
                        danger
                        htmlType="reset"
                        form="projectForm"
                      >
                        {Cancel}
                      </Button>
                    </Space>
                  </Col>
                </Row>
              </Form>
            </CardBody>
          </Card>
        </div>
      </Container>
    </Fragment>
  );
};

export default Newproject;
